__turbopack_context__.v({
  "badge": "Cell-module-scss-module__Fhmkka__badge",
  "checkIcon": "Cell-module-scss-module__Fhmkka__checkIcon",
  "checkbox": "Cell-module-scss-module__Fhmkka__checkbox",
  "columnName": "Cell-module-scss-module__Fhmkka__columnName",
  "crossIcon": "Cell-module-scss-module__Fhmkka__crossIcon",
  "hasTooltip": "Cell-module-scss-module__Fhmkka__hasTooltip",
  "infoIcon": "Cell-module-scss-module__Fhmkka__infoIcon",
  "learnMore": "Cell-module-scss-module__Fhmkka__learnMore",
  "link": "Cell-module-scss-module__Fhmkka__link",
  "no": "Cell-module-scss-module__Fhmkka__no",
  "status": "Cell-module-scss-module__Fhmkka__status",
  "statusBadge": "Cell-module-scss-module__Fhmkka__statusBadge",
  "tooltip": "Cell-module-scss-module__Fhmkka__tooltip",
  "value": "Cell-module-scss-module__Fhmkka__value",
  "withCheckbox": "Cell-module-scss-module__Fhmkka__withCheckbox",
  "yes": "Cell-module-scss-module__Fhmkka__yes",
});
